export type TInteropMapping = {
  id: number
  description: string
  condition: string
}

export enum EInteropV2DecisionAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  CANCEL = 'CANCEL',
}

export type TInteropV2Decision = {
  InteropMappingId: number | null
  action: EInteropV2DecisionAction
  remoteId: string
  followupId?: number
  medEventId?: number
  patientMedEventId?: number
}

export type TTestInteropMappingResponse = {
  legacyMapping?: TInteropMapping
  v2Decisions: TInteropV2Decision[]
}
